import type { ComponentNode } from "./types";

/** Depth-first search for a node by node_id. Returns null if not found. */
export function findNode(
  root: ComponentNode | undefined | null,
  nodeId: string,
): ComponentNode | null {
  if (!root) return null;
  if (root.node_id === nodeId) return root;
  for (const c of root.children ?? []) {
    const hit = findNode(c, nodeId);
    if (hit) return hit;
  }
  return null;
}
